/* src/lib/goto-logement.js — LE geste « ouvrir la fiche du logement »
   depuis un autre écran (navigation pure, zéro montant, zéro appel serveur).

   Contrat existant (CHANTIER OTA Lot O2, Paramètres → Espace voyageur) :
   1. déposer l'id cible dans sessionStorage ('fbz8-goto-logement') ;
   2. émettre l'event 'fbz:goto-logement' — App.jsx bascule l'onglet
      ⌂ Logements, et LogementsV2 lit la cible à son montage pour ouvrir
      la fiche (consommée une fois puis effacée).

   Un sessionStorage indisponible n'empêche pas la bascule d'onglet :
   on arrive sur la liste du parc, jamais sur un écran mort. */

export const GOTO_LOGEMENT_KEY = 'fbz8-goto-logement'
export const GOTO_LOGEMENT_EVENT = 'fbz:goto-logement'

export function ouvrirFicheLogement(lid) {
  if (!lid) return
  try {
    sessionStorage.setItem(GOTO_LOGEMENT_KEY, lid)
  } catch (err) {
    // sessionStorage indisponible : la bascule d'onglet reste utile.
    console.error('[goto-logement] sessionStorage indisponible', err)
  }
  window.dispatchEvent(new CustomEvent(GOTO_LOGEMENT_EVENT))
}
